import PropTypes from 'prop-types';

import {Box, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {NotImplemented} from '@amblique/contentful/app/components/contentful/not-implemented';
import {BlogGridStyle1} from '@amblique/king-living/app/contentful/models/blog-grid/blog-grid-style1';
import {BlogGridStyle2} from '@amblique/king-living/app/contentful/models/blog-grid/blog-grid-style2';

/**
 * BlogGrid component
 * Override this component in your package to provide custom implementation.
 *
 * @param {Object} props - Component props
 * @param {Contentful.BlogGrid} props.component - BlogGrid component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const BlogGrid = ({component, isComplete = true, isFetching = false, ...props}) => {
  const {appearance} = component;
  const styles = useMultiStyleConfig('contentful/blog-grid', {
    component,
    isComplete,
    isFetching,
    variant: appearance,
  });

  return (
    <Box {...styles.root} {...props}>
      {appearance === 'Style 1' ? (
        <BlogGridStyle1 component={component} isComplete={isComplete} isFetching={isFetching} styles={styles} />
      ) : appearance === 'Style 2' ? (
        <BlogGridStyle2 component={component} isComplete={isComplete} isFetching={isFetching} styles={styles} />
      ) : (
        <NotImplemented component={component} isComplete={isComplete} isFetching={isFetching} />
      )}
    </Box>
  );
};

BlogGrid.displayName = 'BlogGrid';
BlogGrid.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
